import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';

export const useLogout = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => apiClient.post('/v1/auth/logout', {}),
  });

  const logout = async () => {
    await mutation.mutateAsync();

    queryClient.resetQueries();
  };

  return {
    isPending: mutation.isPending,
    logout,
  };
};
